import axios from 'axios'
import { env } from '@/filters'
// import { Cookie } from '@/filters'
import qs from 'qs'
import { Message } from 'element-ui'

function getCookie (data) {
  let cookieData = document.cookie.split(';')
  let cookie = {}
  cookieData.forEach((item) => {
    cookie[item.split('=')[0].replace(' ', '')] = item.split('=')[1]
  })
  return cookie[data]
}

let baseUrl = {
  // local: '//localhost:808
  // local: '//192.168.50.105:8040/vbpano-service',
  local: '//apitool.test.vizen.cn/vbpano-service',
  dev: '//apitool.test.vizen.cn/vbpano-service',
  test: '//apitool.test.vizen.cn/vbpano-service',
  // test: `//api.shot.test.vizen.cn`,
  online: '//apitool.vizen.cn/vbpano-service',
  // pre: `//api.${document.location.hostname}`
  pre: '//api.pano.vizen.cn'
}
let r3dApi = {
  local: '//apitool.test.vizen.cn/vbr3d-service',
  dev: '//apitool.test.vizen.cn/vbr3d-service',
  test: '//apitool.test.vizen.cn/vbr3d-service',
  online: '//apitool.vizen.cn/vbr3d-service',
  pre: '//api.r3d.test.vizen.cn '
}

let showUrl = {
  local: '//api.show.test.vizen.cn', // jml，0807，修改url
  dev: `///api.show.dev.vizen.cn`,
  test: `///api.show.test.vizen.cn`,
  online: `//api.show.vizen.cn`,
  pre: '//api.show.pre.vizen.cn' // jml，0807，修改url
}

let shotUrl = {
  local: '//api.shot.test.vizen.cn', // jml，0807，修改url
  dev: `///api.shot.dev.vizen.cn`,
  test: `///api.shot.test.vizen.cn`,
  online: `//api.shot.vizen.cn`,
  pre: '//api.shot.pre.vizen.cn' // jml，0807，修改url
}

let cosUrl = {
  local: '//apitool.test.vizen.cn/cos-service',
  // local: '//api.show.test.vb.com.cn',
  dev: `//apitool.test.vizen.cn/cos-service`,
  test: `//apitool.test.vizen.cn/cos-service`,
  pre: '//cos.test.vizen.cn',
  online: `////apitool.vizen.cn/cos-service`
}

let base = baseUrl[env()]

var interceptor = {
  success (res) {
    if (res.data.code === '10001') {
      Message.warning({
        message: '未登录',
        type: ''
      })
      // Message.success(options)
      // 未登陆时，去登陆页面
      // location.href = '/validationtoken'
      return
    } else {
      return res.data
    }
  },
  error (err) {
    /* 浏览器报跨域问题的时候，err.response === undefined */
    console.log('response', err.response)
    Message.error({
      message: '服务错误，请稍后重试'
    })
    console.log(err)
  }
}

axios.defaults.baseURL = base
axios.defaults.withCredentials = true
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
// axios.defaults.headers['Accept-Language'] = '59a7c786e5b51317f13fb349'
// axios.defaults.headers['Access-Control-Allow-Origin'] = '*'
/*
 * axios默认发送post请求方式为application/json
 * 若需要使用 application/x-www-form-urlencoded 格式发送
 * 需要把参数通过qs转成字符串
 * This is only applicable for request methods 'PUT', 'POST', and 'PATCH'
 */
axios.defaults.transformRequest = [
  function (data) {
    var params = qs.stringify(data)
    return params
  }
]

// Add a response interceptor
axios.interceptors.response.use(interceptor.success, interceptor.error)

axios.interceptors.request.use((config) => {
  // Do something before request is sent
  if (getCookie('authorization')) {
    config.headers['Authorization'] = getCookie('authorization')
  }
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})
/* *
 * 实例化一个axios，用于上传接口，数据类型为formdata格式
 */
var instance = axios.create()
instance.defaults.transformRequest = [
  function (data) {
    return data
  }
]
instance.interceptors.response.use(interceptor.success, interceptor.error)

// 调用三维服务接口
var instance2 = axios.create({
  baseURL: r3dApi[env()]
})
instance2.interceptors.response.use(interceptor.success, interceptor.error)

instance2.interceptors.request.use((config) => {
  // Do something before request is sent
  if (getCookie('authorization')) {
    config.headers['Authorization'] = getCookie('authorization')
  }
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

// 调用应用平台的注册接口
var instance3 = axios.create({
  baseURL: showUrl[env()]
})
instance3.interceptors.response.use(interceptor.success, interceptor.error)

// 调用制作平台
var instance4 = axios.create({
  baseURL: shotUrl[env()]
})
instance4.interceptors.response.use(interceptor.success, interceptor.error)

// 调用cos上传服务
var instance5 = axios.create({
  baseURL: cosUrl[env()]
})
instance5.interceptors.response.use(interceptor.success, interceptor.error)

/* *
 * 添加vue全局插件api
 * 通过添加Vue实例方法，调用：vm.$api
 */
export default {
  install (Vue) {
    Vue.prototype.$api = {
      // 校验token
      validationToken (params) {
        return axios.get('/common/validationToken', params)
      },
      login (params) {
        // debugger
        if (params.type === 'shot') {
          return instance4.post('/common/login', params)
        } else {
          return instance3.post('/common/login', params)
        }
      },
      // logout (params) {
      //   if (params === 2) {
      //     return instance4.get('/common/logout', params)
      //   } else {
      //     return instance3.get('/common/logout', params)
      //   }
      // },
      logout (params) {
        return axios.get('/logout', params)
      },
      getResourceInfo (params) {
        if (params === 2) {
          return instance4.get('/user/resourceInfo', params)
        } else {
          return instance3.get('/user/resourceInfo', params)
        }
      },
      getUserInfo (params) {
        return axios.get('/userInfo', params)
      },
      getStitchList (params) {
        return axios.get('/material/pano/searchAutoStitch', params)
      },
      getStitchPanoId (params) {
        return axios.get('/material/pano/generateMaterialId', params)
      },
      // 删除删除拼接任务
      deleteAutoStitch (params) {
        return axios.delete('/material/pano/deleteStitchPanos', params)
      },
      // 调取cos单独服务获取cos 的签名
      getCosSignature (params) {
        return instance5.get('/file/generateSign', params)
      },
      // 保存单张素材
      saveOneStitchPic (params) {
        return axios.put('/material/pano/autoStitchPic', params)
      },
      // 保存多张素材
      saveAllStitchPic (params) {
        return axios.put('/material/pano/saveProcessMaterial', params)
      },
      // 保存水平图
      saveAnchorInfo (params) {
        return axios.get('/material/pano/saveAnchorInfo', params)
      },
      // 删除单张图片
      deleteAutoStitchPic (params) {
        return axios.delete('/material/pano/autoStitchPic', params)
      },
      // 获取一个任务的信息
      getInfoById (params) {
        return axios.get('/material/pano/getInfoById', params)
      },
      // 开始一个拼接任务
      startProcess (params) {
        return axios.get('/material/pano/startProcess', params)
      },
      getSkyImageList (params) {
        // 获取补天图
        // params :
        return axios.get(`/material/pano/patchIds/${params.panoId}`, params)
      },
      saveSkyPatch (params) {
        // 保存补天图
        // params :patchId、url、panoId
        return axios.get(`/material/pano/saveSkypatch`, params)
      },
      startSecondProcess (params) {
        // 二次拼接（新服务）
        // params
        return axios.get(`/material/pano/startSecondProcess`, params)
      },
      startPanoFilter (params) {
        // 滤镜处理全景
        // panoId 全景id，属于restful风格的http请求调用
        // type ，1-模板，2-曲线调参（默认是1）
        // templateId 滤镜模板 ID ，默认是BlackWhiteFilte
        return axios.post(`/material/pano/startPanoFilter/${params.panoId}`, params)
      },
      // 全景增加调轴或调整初始视角处理
      updatePanoHeadingPitchZhou (params) {
        return axios.post(`/material/pano/nextProcess/${params.materialId}`, params)
      },
      caclePanoFilter (params) {
        // 取消滤镜处理全景
        return axios.post(`/material/pano/canclePanoFilter/${params.panoId}`)
      },
      saveBgroundPatch (params) {
        // 保存补地信息（保存删除用一个）
        return axios.put(`/material/pano/saveBgroundPatch`, params)
      },
      preStep (params) {
        // 拼接返回上一步
        return axios.get(`/material/pano/preStep`, params)
      },
      exportPano (params) {
        // 导出全景图
        return axios.put(`/material/pano/exportPano`, params)
      },
      // 所有三维相关接口以r3d开头
      /* 三维相关接口开始 */
      // 生成id
      // 校验token
      r3dValidationToken (params) {
        return instance2.get('/common/validationToken', params)
      },
      r3dGetMaterialId (params) {
        return instance2.get(`/vbr3d/model/generateMaterialId`, params)
      },
      // 获取列表
      r3dGetTasklist (params) {
        return instance2.get(`/vbr3d/model/search`, params)
      },
      // 保存单张素材
      r3dSaveOneMaterial (params) {
        return instance2.put(`/vbr3d/model/saveOneMaterial`, params)
      },
      // 保存多个素材
      r3dSaveMaterials (params) {
        return instance2.put(`/vbr3d/model/saveMaterials`, params)
      },
      r3dGetInfoById (params) {
        // params = materialId
        return instance2.get(`/vbr3d/model/${params}`)
      },
      r3dStartProcess (params) {
        return instance2.get('/vbr3d/model/startProcess', params)
      },
      // 删除三维任务
      r3dDeleteTask (params) {
        // params = materialId
        return instance2.delete(`/vbr3d/model/delete`, params)
      },
      r3dExport (params) {
        // params = materialId
        return instance2.put(`/vbr3d/model/exportVbr3d`, params)
      },
      // 获取用户登录信息
      r3dGenerateToken (params) {
        // params = materialId
        return instance2.get(`/vbr3d/model/generateToken`, params)
      },
      r3dSaveInfo (params) {
        // params = materialId
        return instance2.post(`/vbr3d/model/saveInfo`, params)
      },
      // 三维修模获取obj地址
      r3dGetObjAddress (id) {
        // params = materialId
        return instance2.get(`/vbr3d/model/getAddress/${id}`)
      },
      r3dSaveDeleteFaces (params) {
        return instance2.post(`/vbr3d/model/saveDeleteFaces`, params)
      }
      /* 三维相关接口结束 */
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js